import { Group } from '@mantine/core';
import { DataQualityClassification } from '@repo/common/enums/dataQualityClassification';
import {
	formatScore,
	getScoreClassification,
} from '@repo/common/utils/dataQuality';
import { Badge, Text } from '@repo/foundations';
import { memo } from 'react';
import { DataQualityBadge } from '../DataQualityBadge';
import { LABEL_SIZES, type SizeOptions } from './constants';

export interface QualityScorePercentageProps {
	score: number | undefined;
	size?: SizeOptions;
	displayBadge?: boolean;
	showUnavailableBadge?: boolean;
}

export const QualityScorePercentage = memo(
	({
		score,
		size = 'md',
		displayBadge = false,
		showUnavailableBadge = false,
	}: QualityScorePercentageProps) => {
		const classification = getScoreClassification(score);

		if (classification === DataQualityClassification.UNAVAILABLE) {
			return (
				<Group spacing="xs">
					<Text
						size={LABEL_SIZES[size].score}
						fw={600}
						color="text/secondary/default"
					>
						---
					</Text>
					{showUnavailableBadge && (
						<Badge variant="default" size="sm">
							unavailable
						</Badge>
					)}
				</Group>
			);
		}

		return (
			<Group spacing={0}>
				<Text size={LABEL_SIZES[size].score} fw={600}>
					{formatScore(score || 0)}
				</Text>
				<Text size={LABEL_SIZES[size].percent} fw={600} pr="xs">
					%
				</Text>
				{displayBadge && <DataQualityBadge classification={classification} />}
			</Group>
		);
	}
);

QualityScorePercentage.displayName = 'QualityScorePercentage';
